// TODO: replace any with proper types
import { ProtoWhereFilter } from 'src/app/@core/types';

export function harmonizeLoopbackFilter(filter: { where: ProtoWhereFilter }): { where: ProtoWhereFilter } {
  if (filter.where && !filter.where.and) {
    filter.where = {
      and: [filter.where],
    };
  }

  if (!filter.where) {
    filter.where = {
      and: [],
    };
  }

  return filter;
}
